import { PaperProps, styled } from "@mui/material";
import { StyledMarkdown } from "components/layout/StyledMarkdown";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { useUrlSelectLayer } from "hooks/layerSetHooks";

import { LayerSet } from "types/types";

import LayerSetAllFormatsAccordion from "./LayerSetAllFormatsAccordion";
import { LayerSetDialogTags } from "./LayerSetDialogTags";
import { LayerSetDownloadAccordion } from "./LayerSetDownloadAccordion";

interface Props extends PaperProps {
  layerSet: LayerSet;
}

export function LayerSetDialogSidePanel(props: Props) {
  const { layerSet, ...paperProps } = props;
  const { selectedLayer } = useUrlSelectLayer(layerSet.layerList);
  return (
    <StyledPaper {...paperProps} elevation={0}>
      <div data-tour="step-4">
        <StyledMarkdown content={layerSet.description} />
        <LayerSetDialogTags layerList={layerSet.layerList} />
      </div>

      <div className="overflow-container" data-tour="step-5">
        {/* <LayerSetDescriptionAccordion /> */}
        <LayerSetAllFormatsAccordion selectedLayer={selectedLayer} />
        <LayerSetDownloadAccordion selectedLayer={selectedLayer} />
      </div>
    </StyledPaper>
  );
}

const StyledPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  .overflow-container {
    overflow-y: auto;
  }
`;
